<template>
  <div class="container">
    <h4>User Profile</h4>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-3">
        <avatar :username="user.displayName" :size="55" :backgroundColor="user.bgColor"></avatar>
        
      </div>
      <div class="col-7"><h4 class="mt-3">Avatar Color:</h4></div>

      <div class="col-12 mt-2">
        <a v-for="color in colorList" class="colorBox m-1" :class="color.class" :key="color.bgColor" @click.prevent="chooseColor(color.bgColor)">&nbsp;</a>
      </div>
    </div>
    
    <form class="form mt-2">
      <div class="form-group">
        <label>Display Name</label>
        <input type="text" class="form-control" v-model="user.displayName" placeholder="Display Name">
      </div>
      <div class="form-group">
        <label>Email</label>
        <input type="text" class="form-control" v-model="user.email" placeholder="Email">
      </div>
      <hr>
      <div class="form-group">
        <label>Box Name</label>
        <input type="text" class="form-control" v-model="user.boxName" placeholder="Box Name">
      </div>
      <div class="form-group">
        <label>Box City, State</label>
        <input type="text" class="form-control" v-model="user.boxCityState" placeholder="Box city and state">
      </div>
    </form>

    <button @click="updateProfile" class="btn btn-outline-primary">Update Profile</button>
    <button @click="logOut" class="btn btn-outline-danger">Logout</button>

    <!--
    <button @click="uploadWorkouts" class="btn btn-outline-warning">Upload Workouts</button>
    <button @click="seedWorkouts" class="btn btn-outline-warning">Seed Workout Data</button>
    -->
    
  </div>
</template>

<script>

import Toolbar from '@/components/toolbar'
import Avatar from 'vue-avatar'
import firebase from 'firebase'
import 'firebase/firestore'

//import Workout from '@/workoutData.js'

export default {
  name: 'profile',
  components: {
    Toolbar,
    Avatar
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  data () {
    return {
      msg: 'This is the user profile page',
      bgColor: "",
      colorList: [
        {
          class:'--blue',
          bgColor: '#007bff'
        }, 
        {
          class:'--indigo',
          bgColor: '#6610f2'
        }, 
        {
          class:'--pink',
          bgColor: '#e83e8c'
        }, 
        {
          class:'--red',
          bgColor: '#dc3545'
        }, 
        {
          class:'--orange',
          bgColor: '#fd7e14'
        }, 
        {
          class:'--teal',
          bgColor: '#20c997'
        },
        {
          class:'--cyan',
          bgColor: '#17a2b8'
        },
        {
          class:'--grey',
          bgColor: '#868e96'
        },
        {
          class:'--white',
          bgColor: '#fff'
        },
        {
          class: '--black',
          bgColor: '#111'
        }
      ]
    }
  },
  methods: {
    logOut() { 
      firebase.auth().signOut().then(() =>{
        this.$store.commit('resetStore')
        this.$router.replace('login')
      })
    },
    chooseColor: function(color) {
      this.$store.commit('setBgColor', color)
      console.log(`Color Picked: ${color}`)
    },
    updateProfile: function() {
      this.$store.commit('updateUser')
      this.$router.push('home')
      this.$notify({
        group: 'note',
        text: 'Profile Updated',
        type: 'save'
      })
    },
    /*
    uploadWorkouts () {
      this.$store.commit('uploadNamedWorkouts')
    },
    seedWorkouts() {
      let seed = 0
      let userDocRef = this.$store.state.db.collection('users').doc(this.$store.getters.userId)
      

      this.workouts.forEach(workout => {
        userDocRef.collection('workouts').add({
          'date': new Date(workout.date),
          'workoutType': workout.workoutType,
          'description': workout.description,
          'tags': workout.tags,
          'result': workout.result,
          'notes': workout.Notes,
          'Weather': workout.Weather 
        })
        seed++
        if(this.workouts.length == seed) {
          console.log(`Added ${seed} records.`)
        }
        
      })
      
    }*/
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .colorBox {
    width: 17.5%;
    height: 45px;
    float: left;
  }
  .--blue {
    background-color: #007bff
  }
  .--indigo {
    background-color: #6610f2
  }
  .--pink {
    background-color: #e83e8c
  }
  .--red {
    background-color: #dc3545
  }
  .--orange {
    background-color: #fd7e14
  }
  .--teal {
    background-color: #20c997
  }
  .--cyan {
    background-color: #17a2b8
  }
  .--grey {
    background-color: #868e96
  }
  .--white {
    background-color: #FFF;
    border: 2px solid grey;
  }
  .--black {
    background-color: #111
  }



</style>


// WEBPACK FOOTER //
// src/components/profile.vue